import React, { useEffect, useState } from 'react';
import Button from '../../../../../../components/Forms/Button';
import Submission from '../Submission';
import { Container } from './styles';
import MyPapers from '../MyPapers';
import MyPapersOrientator from '../MyPapersOrientator';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { authTitle, supportNumber } from '../../../../../../config';
import Whatsapp from '../../../../../../components/Whatsapp';

import ListSubmission from '../ListSubmission';
import CourseProductsSubscriptionModule from 'src/pages/CourseProductSubscription';
interface IParams {
  tab: string;
}

const CientificHome: React.FC = () => {
  const [type, setType] = useState('profile');
  const { tab } = useParams<IParams>();

  const [validTab, setValidTab] = useState({
    home: '',
    submeter: 'submeter'
  });

  useEffect(() => {

    if (tab && validTab[tab]) {
      setType(validTab[tab]);
    }

  }, [tab])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>

      <Container >

        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'center', padding: '10px' }}>
          <Link to="/trabalhos"><Button onClick={() => setType('profile')}>Minha inscrição</Button></Link>
          <Link to="/trabalhos"><Button onClick={() => setType('')}>Meus trabalhos</Button></Link>
          <Link to="/trabalhos"><Button onClick={() => setType('orientator')}>Sou orientador</Button></Link>
          <Link to="/trabalhos/submeter"><Button onClick={() => setType('submeter')}>Submeter trabalho</Button></Link>

          {/*   <a download href="/apoio/2024_regulamento_X_Mostra_Ensino_Pesquisa_Extensao.pdf">
            <Button  >Regulamento</Button>

          </a>
          <a download href="/apoio/2024_Mostra_Ensino_Pesquisa_Extensao_UFCSPA.pptx">
            <Button  >Template PPT</Button>

  </a> */}

          <Whatsapp number={supportNumber} text={`${authTitle}: Quero submeter um trabalho`} message="Suporte Técnico" />

        </div>

        {type === 'profile' && <div className='column'>

          <h2 style={{ textAlign: 'center', width: '100%', fontSize: '18px', color: '#333', lineHeight: '24px' }}>A submissão de trabalhos inicia no dia 04 de abril de 2025</h2>
          <div className='column gap-sm'>
            <h2 style={{ textAlign: 'center', width: '100%', fontSize: '18px', color: '#333', lineHeight: '24px', marginTop: '30px' }}>Modelos de pôster</h2>

            <a href="https://congresso2025.ufcspa.edu.br/event/images/67ea6435be8b068de5a9cac9/29afaefedef3ece810b951550cec4845.pptx" target="_BLANK"><button className="greenButton2">4º CONGRESSO UFCSPA: SAÚDE E MUDANÇAS CLIMÁTICAS: DIÁLOGOS PARA UM FUTURO SUSTENTÁVEL</button></a>
            <a href="https://congresso2025.ufcspa.edu.br/event/images/67ea6435be8b068de5a9cac9/a2e4c5dc4c029a3fe380bfe7a024789b.pptx" target="_BLANK"><button className="greenButton2">XI MOSTRA DE ENSINO, PESQUISA E EXTENSÃO DA UFCSPA

            </button></a>

            <h2>Selecione as suas oficinas</h2>

            <CourseProductsSubscriptionModule />
          </div>
        </div>}
        {type === '' && <MyPapers />}
        {type === 'orientator' && <MyPapersOrientator />}
        {type === 'submeter' && <ListSubmission />}
        {type === 'submeter-trabalho' && <Submission />}


      </Container>
    </>
  );
};
export default CientificHome;
